import * as React from "react";
import ArrepentimientoContainer from "../containers/arrepentimiento-container";

export default function ArrepentimientoPage() {
  return <ArrepentimientoContainer></ArrepentimientoContainer>;
}
